import { render } from "./SearchTabs.vue?vue&type=template&id=06f89448&scoped=true"
import script from "./SearchTabs.vue?vue&type=script&lang=js"
export * from "./SearchTabs.vue?vue&type=script&lang=js"

import "./SearchTabs.vue?vue&type=style&index=0&id=06f89448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f89448"]])

export default __exports__